import React, { Component } from 'react';
import { Icon } from '@trlogic/ui-pack';
import moment from 'moment';
import { LookupType, SocialMediaStatus, WatchlistCustomerDomains } from '../../../domain/watchlist/WatchlistCustomerDomains';
import CustomLoading from '../../custom/CustomLoading';
import WatchlistDataNotFoundComponent from './WatchlistDataNotFoundComponent';
import LanguageUtil from '../../../util/LanguageUtil';

class WatchlistCustomerSocialMediaComponent extends Component<Props, State> {
  public state: State = new State();

  render() {
    const { response, customerLoading } = this.props;

    const sortedAccounts = response?.socialMedia.accounts.sort((a, b) => {
      if (a.status === 'FOUND' && b.status !== 'FOUND') return -1;
      if (a.status !== 'FOUND' && b.status === 'FOUND') return 1;
      if (a.status === 'NOT_FOUND' && b.status !== 'NOT_FOUND') return -1;
      if (a.status !== 'NOT_FOUND' && b.status === 'NOT_FOUND') return 1;
      return a.name.localeCompare(b.name);
    });

    return (
      <div className={'w-full flex flex-col h-auto bg-[#F9FAFB] rounded-md border-[1px] border-[#E0E4E8] rounded-xl'}>
        <div className={'border-b-[1px] border-[#E0E4E8] p-4'}>
          {LanguageUtil.get({ id: 'pages.alert.socialMedia.socialMediaInformation', defaultMessage: 'Social Media Information' })}
        </div>
        <div className={'flex flex-col rounded-xl bg-white'}>
          {customerLoading ? (
            <CustomLoading />
          ) : response == undefined ? (
            <WatchlistDataNotFoundComponent />
          ) : (
            <div className={'grid grid-cols-6 grid-flow-row gap-4 p-4'}>
              {sortedAccounts?.map((response, index) => {
                return (
                  <div key={index} className={'flex flex-col w-full 2xl:col-span-1 md:col-span-2 col-span-8 gap-4'}>
                    <div className={'flex flex-col border rounded w-full p-4 gap-y-2'}>
                      <div className='flex w-full flex-row items-center rounded-t-md justify-between'>
                        <div className={'flex justify-center items-center'}>
                          {response.status == SocialMediaStatus.FOUND ? (
                            <Icon icon={`${response.name.toLowerCase()}-svg`} size={24} color={'black'} className={'shrink-0'} />
                          ) : (
                            <Icon icon={`${response.name.toLowerCase()}-grey-svg`} size={24} color={'black'} className={'shrink-0'} />
                          )}
                          <span className={'text-[13px] ml-[10px]'}>{response.name.charAt(0).toUpperCase() + response.name.slice(1).toLowerCase()}</span>
                        </div>
                        <div
                          className={`${response.status == SocialMediaStatus.FOUND ? 'bg-[#DBFFEA] text-[#027A48]' : response.status == SocialMediaStatus.NOT_FOUND ? 'bg-[#FFF1F3] text-[#D2332F]' : 'bg-[#F2F4F7] text-[#4F4F4F]'}
                           rounded-[500px] px-[8px] py-[2px] text-[10px] flex items-center gap-1`}
                        >
                          {this.getIcon(response.status, response.type)}
                          {response.status.replace('_', ' ')}
                        </div>
                      </div>
                      <div className={'flex gap-3'}>
                        <img
                          alt='logo_typeface'
                          className={'w-[40px] h-[40px] rounded-[5px]'}
                          src={response.avatar ? `data:image/jpeg;base64,${response.avatar}` : `/icons/CustomerIcons/not-user.svg`}
                        />
                        <div className={'flex flex-col'}>
                          <span className={'text-[#4F4F4F] font-medium text-[13px]'}>
                            {LanguageUtil.get({ id: 'pages.alert.socialMedia.lastInvestigated', defaultMessage: 'Last Investigated' })}
                          </span>
                          <span className={'text-[#828282] font-normal text-[13px]'}>{moment(response.lastUpdatedTime).format('LLL')}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    );
  }

  private getIcon = (status: SocialMediaStatus, type: LookupType) => {
    if (status == SocialMediaStatus.FOUND) {
      switch (type) {
        case LookupType.EMAIL:
          return <Icon icon={'found-mail'} size={13} color={'#027A48'} />;
        case LookupType.PHONE:
          return <Icon icon={'found-phone'} size={13} color={'#027A48'} />;
      }
    } else if (status == SocialMediaStatus.NOT_FOUND) {
      return <Icon icon={'not-found'} size={13} color={'#D2332F'} />;
    } else {
      return <Icon icon={'unknown'} size={13} color={'#4F4F4F'} />;
    }
  };
}

interface Props {
  response: WatchlistCustomerDomains | undefined;
  customerLoading: boolean;
}

class State {}

export default WatchlistCustomerSocialMediaComponent;
